import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("md-skeleton animate-pulse rounded-md", className)}
      {...props} />
  );
}

export { Skeleton }
